import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {
  ContentExpander,
  ContentExpanderController
} from './models/content-expander.interfaces';

@Component({
  selector: 'idp-content-expander',
  templateUrl: './content-expander.component.html',
  styleUrls: ['./content-expander.component.scss']
})
export class ContentExpanderComponent implements OnInit, OnChanges {
  @Input() content: ContentExpander = {} as ContentExpander;

  @Output() count: EventEmitter<number> = new EventEmitter<number>();
  @Output() previousCounter: EventEmitter<number> = new EventEmitter<number>();
  controller: ContentExpanderController = {
    balance: 0,
    expand: false,
    count: 0
  };

  constructor(public elementRef: ElementRef) {}

  ngOnInit(): void {
    this.init();
  }

  init(): void {
    this.controller.count = this.content.counts.default;
    this.controller.balance =
      this.content.counts.total - this.content.counts.default;
  }

  // Add ngOnChanges to detect changes in content
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['content'] && !changes['content'].firstChange) {
      this.updateController();
    }
  }

  // Separate method to update the controller without resetting everything
  updateController(): void {
    const newBalance = this.content.counts.total - this.controller.count;
    this.controller.balance = newBalance >= 0 ? newBalance : 0;
  }

  showContent(
    content: ContentExpander,
    controller: ContentExpanderController
  ): void {
    if (content.collapse.full) {
      this.checkBalanceCount(
        controller.balance,
        content.counts.increment,
        controller.count,
        content.counts.total,
        content.counts.default
      );
    }
  }

  checkBalanceCount(
    balance: number,
    newExpandCount: number,
    previousCount: number,
    total = 0,
    initCount = 3
  ): void {
    if (previousCount === total) {
      previousCount = 0;
      newExpandCount = initCount;
      balance = total - previousCount;
    } else if (balance <= newExpandCount) {
      newExpandCount = balance;
    }
    const continueExpand = this.setExpanderData(
      previousCount,
      newExpandCount,
      balance,
      total
    );
    this.setExpand(continueExpand);
    this.count.emit(this.controller.count);
    this.previousCounter.emit(previousCount);
  }

  setExpanderData(
    previousCount: number,
    newCount: number,
    balance = 0,
    total = 0
  ): boolean {
    this.controller.count = previousCount + newCount;
    this.controller.balance = balance - newCount;
    return !(this.controller.count === total);
  }

  setExpand(continueExpand: boolean): void {
    this.controller.expand = continueExpand ? false : !this.controller.expand;
  }
}
